import { createFileRoute, redirect } from "@tanstack/react-router";
import { resolveLegacyEpisode } from "@/lib/seo/legacyPaths.functions";

export const Route = createFileRoute("/_app/podcast/$slug")({
  loader: async ({ params }) => {
    const match = await resolveLegacyEpisode({ data: params.slug });
    if (match) {
      throw redirect({
        to: "/podcasts/$podcastId/episodes/$episodeId",
        params: { podcastId: match.podcastId, episodeId: match.episodeId },
        statusCode: 301,
      });
    }
    throw redirect({ to: "/podcasts", statusCode: 301 });
  },
  component: () => null,
});
